import { Chart } from 'devextreme-react';
import { Series } from 'devextreme-react/chart';
import LoadIndicator from 'devextreme-react/load-indicator';
import { useEffect, useState } from 'react';
import reportService from '@/projects/platform/services/report-service';

export default function AvgSalesPriceByCity(props: any) {
    var params: string;
    const { retailerId, startDate, endDate } = props;
    const [dataSource, setDataSource] = useState([]);
    const [loading, setLoading] = useState(true);

    function filter() {
        params = '';
        for (const key of Object.keys(props)) {
            if (props[key]) {
                params += `${key}=${props[key]}&`;
            }
        }
        params = params.slice(0, -1);
    }

    useEffect(() => {
        setLoading(true);
        filter();
        reportService.getAvgSalesPriceByCity(params)
            .then((response) => {
                setDataSource(response.data.searchResult.reverse());
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
                throw new Error('Data Loading Error');
            });
    }, [retailerId, startDate, endDate]);

    return (
        <>
            <LoadIndicator visible={loading} />
            <Chart id="chart" dataSource={dataSource} rotated={true}>
                <Series

                    valueField="avgAmount"
                    argumentField="city"
                    name="Avg Sales Price By City"
                    type="bar"
                    color="#ffaa66" />
            </Chart>
        </>
    );
}
